module.exports = __webpack_public_path__ + "2a974c8595172296c484454d881da87e.pdf";